// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__1R69w","title":"AfterBackImages_title__2NxII","images":"AfterBackImages_images__pLvAK"};